<template>
    <b-overlay :show="tableLoading" rounded="sm" >
        <b-modal
        id="order-template-export"
        @ok="submitForm"
        header-class="p-0"
        footer-class="d-flex justify-content-center border-0"
        content-class="custom-model-wrap"
      >
        <template #modal-title>
          <div class="title-block text-center p-2">{{ $translate('language_settings') }}</div>
          <div class="close-btn" @click="cancel()">x</div>
        </template>
        <form class="my-3 py-3" @submit.stop.prevent="submitForm">
          <b-row>
            <a id="export-sample-file-btn" href="javascript:void(0)" title="Import" class="decoration-off text-success" @click="exportSampleFile">
              <i class="fas fa-file-excel fa-lg me-2"></i>{{ $translate('download_language_setting_file') }}
            </a>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="12" class="mb-3">
              <label for="file-input"><strong>{{ $translate('upload_language_file') }}</strong></label>
              <input type="file" id="file-input" @change="handleFileUpload" class="form-control mt-2" required />
            </b-col>
          </b-row>
        </form>
        <template #modal-footer="{ ok, cancel }">
          <b-button id="import-btn" size="sm" variant="info" @click="ok()">{{ $translate('import') }}</b-button>
          <b-button id="cancel-btn" size="sm" variant="info" @click="cancel()">{{ $cancelLabel() }}</b-button>
        </template>
      </b-modal>
      <b-modal
      id="update-settings"
      @ok="updateSettings"
      header-class="p-0"
      footer-class="d-flex justify-content-center border-0"
      content-class="custom-model-wrap"
    >
      <template #modal-title>
        <div class="title-block text-center p-2">{{ $translate('language_settings') }}</div>
        <div class="close-btn" @click="cancel()">x</div>
      </template>
      <form class="my-3 py-3" @submit.stop.prevent="updateSettings">
       
        <b-row>
            <input type="hidden" v-model="model.value_id">
          <b-col cols="12" class="mb-3">
            <label for="file-input"><strong>{{ $translate('value_en') }}</strong></label>
            <input type="text" v-model="model.value_en" id="file-input" class="form-control mt-2" required />
          </b-col>
          <b-col cols="12" class="mb-3">
            <label for="file-input"><strong>{{ $translate('value_es') }}</strong></label>
            <input type="text" v-model="model.value_es" id="file-input" class="form-control mt-2" required />
          </b-col>
        </b-row>
      </form>
      <template #modal-footer="{ ok, cancel }">
        <b-button id="import-btn" size="sm" variant="info" @click="ok()">{{ $translate('save') }}</b-button>
        <b-button id="cancel-btn" size="sm" variant="info" @click="cancel()">{{ $cancelLabel() }}</b-button>
      </template>
    </b-modal>
        <b-card class="inner-block health-listing">
            <b-card-header>
            
                <b-row class="mt-2">
                   
                    <!-- <b-col cols="2" md="1" lg="1"
                        class="d-flex align-items-center justify-content-center"><strong>health</strong></b-col>
                    <b-col cols="10" md="11" lg="11" class="d-flex"> -->
                    <b-col cols="12"  class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button"
                    >
                        <b-input type="text" :placeholder="$translate('search_filter')" v-model="query"></b-input>
                        <b-button
                        id="import-checkoff-item-btn"
                        variant="blue-icon"
                        v-b-tooltip.hover
                        :title="$translate('import')"
                        @click="openModal()"
                      
                      >
                        <img src="@/assets/images/icon/import.svg" />
                      </b-button>
                    
                    
                    </b-col>
                </b-row>
         
            </b-card-header>
            <b-card-body class="button-off">
                <b-col class="page-block">
                    <strong>
                        {{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{ pageCount }} {{
                            $translate('total') }}:
                        {{ pagination.total }}
                    </strong>
                </b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table show-empty :empty-text=" $translate('records_not_found')" id="rosterTable" responsive :items="language" :fields="fields">
                        <template>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(id)="row">
                            <b-button :id="'view-roster-btn-'+row.item.id" @click="view(row.item)"  class="mr-2 test-view-document-type-btn" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                            <!-- <b-button @click="view(row.item.id)" v-if="hasPermissionView" class="mr-2" variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button> -->
                        </template>
                     
                    </b-table>
                </b-col>
                <b-row>
                    <b-col>
                        <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                            :total-rows="pagination.total" :per-page="pagination.pageSize" aria-controls="customerTable"
                            :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                            align="right"></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'



export default {
    name: 'health-table',
    mixins: [popupMixins, permissionsMixins],
    components: {
  
       
    },
    props: {
        type: {
            type: String,
        },
        title: String,
    },
    data() {
        return {
            model:{
                value_en: '', 
                value_es: '', 
                value_id: '',
            },
           
            query: '',
            tableLoading: false,
            
        }
    },
    computed: {
        componentName() { return this.$translate('language_settings') },
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'key', label: this.$translate('key')  },
                { key: 'value_en', label: this.$translate('value_en')  },
                
                { key: 'value_es', label: this.$translate('value_es') },
            
               
            ]
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        language() {
            const language = this.$store.state.language.items
           
            return language
        },
        pagination() {
            return this.$store.state.language.pagination || {page: 1}
        },
      
    },

    watch: {
        language: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
        // filters: {
        //     handler: function () {
             
        //         this.doSearch(true)
        //     },
        //     deep: true,
        // },
    },

    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },

    methods: {
       
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        resetFilters() {
            this.setDefaultDateRange();
            this.doSearch()
        },
        async doSearch() {
         
            try {
                this.$store.commit('language/updateFilter', {
                                                query: this.query,
                                                filters: this.filters
                                                });
                this.tableLoading = true
                const {
                    pagination: { page },
                    query,
                    filters
                } = this
                await this.$store.dispatch('language/fetch', {
                    query,
                    page,
                    filters
                })
            } catch (error) {
                console.error('loading error', error)
            }
        },
        view(item) {
            // Set the values from the selected row item
                this.model.value_en = item.value_en;
                this.model.value_es = item.value_es;
                this.model.value_id = item.id;
                // Open the modal
                this.$bvModal.show('update-settings');
        },
       
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },

     handleFileUpload(event) {
      this.translations = event.target.files[0];
    },
    async initializeFormValues() {
      const languages = this.$store.state.languages;
      this.formValues = Object.keys(languages).reduce((acc, lang) => {
        acc[lang] = { ...languages[lang] };
        return acc;
      }, {});
      this.labels = Object.keys(languages).reduce((acc, lang) => {
        acc[lang] = { ...languages[lang] };
        return acc;
      }, {});
    },
    updateValue(event, langKey, key) {
      this.formValues[langKey][key] = event;
    },
    async handleSubmit() {
      this.updating = true;
      try {
        await this.$store.dispatch('setLanguage', this.formValues);
        this.genericToast(this.componentName, this.$translate('updated'), 'success', `${this.componentName} ${this.$translate('update_alert')}`);
        this.$nextTick(() => {
          window.location.reload();
        });
      } catch (error) {
        this.doToast(this.$translate('error'), error.message, 'danger');
        console.log(error);
      } finally {
        this.updating = false;
      }
    },
    async openModal() {
      this.$bvModal.show('order-template-export');
    },
    async exportSampleFile() {
      try {
        this.updating = true;
        await this.$store.dispatch('languages/sampleExcel');
      } catch (error) {
        this.doToast(this.$translate('error'), error.message, 'danger');
      } finally {
        this.updating = false;
      }
    },
    async submitForm() {
      const formData = new FormData();
      formData.append('translations', this.translations);

      try {
        this.updating = true;
        await this.$store.dispatch('languages/excelImport', formData);
        this.genericToast(this.componentName, this.$translate('updated'), 'success', `${this.componentName} ${this.$translate('update_alert')}`);
        this.$nextTick(() => {
          window.location.reload();
        });
      } catch (error) {
        this.doToast(this.$translate('error'), error.message, 'danger');
        this.updating = false;
      }
    },
    loadNextChunk() {
        this.loading = true; // Show loader when loading new chunk
        const keys = Object.keys(this.labels.en);
        const start = this.currentChunk * this.chunkSize;
        const end = Math.min(start + this.chunkSize, keys.length); // Ensure we don't go beyond the length of keys
        const nextChunk = keys.slice(start, end);

        nextChunk.forEach((key) => {
            this.$set(this.visibleTranslations, key, this.labels.en[key]);
        });

        this.currentChunk += 1;

        if (end >= keys.length) {
            this.loading = false;
            if (this.observer && this.$refs.infiniteScrollTrigger) {
            this.observer.unobserve(this.$refs.infiniteScrollTrigger);
            }
        }
        // Hide loader when loading is complete
        },

    onIntersection(entries) {
      const entry = entries[0];
      if (entry.isIntersecting) {
        this.loadNextChunk();
      }
    },
    updateSettings() {
            this.submitting = true
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$store
                        .dispatch(
                            'language/update',
                            this.model
                        )
                        .then(() => {
                        
                            this.$bvModal.hide('update-settings');
                                this.$nextTick(() => {
                                    this.genericToast(this.componentName, this.$translate('updated'), 'success', `${this.componentName} ${this.$translate('update_alert')}`);
                                    this.$nextTick(() => {
                                    window.location.reload();
                                    });
                                })
                          
                        })
                        .catch(error => {
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                            console.log(error)
                        })
                        .finally(() => {
                            this.submitting = false
                        })
                } else {
                    this.submitting = false
                }
            })
        },
    
     
    },
}
</script>
<style></style>
